import React, { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TaskIdV2 } from 'api/models';
import { Modal } from 'components/atoms/modal';
import {
  rearrangeTasksInProjectTemplate,
  updateTaskInProjectTemplate,
} from 'data/templates/projects/actions';
import { useTranslation } from 'hooks/use-translation';
import { RearrangeTree } from './tree';
import { PositionData, TaskAsParent } from './types';

interface Props {
  visible: boolean;
  onClose: () => void;
  currentTaskId: TaskIdV2;
}

export const RearrangeTasks: FC<Props> = ({
  currentTaskId,
  visible,
  onClose,
}) => {
  const dispatch = useDispatch();
  const [actions, setActions] = useState<Record<number, PositionData>>({});

  const updateActions = useCallback(
    (action: PositionData) => {
      setActions({ ...actions, [action.taskId]: action });
    },
    [actions],
  );

  const rearrangeTasks = useCallback(() => {
    dispatch(rearrangeTasksInProjectTemplate(Object.values(actions)));

    const tasksBecomingSubtasks = Object.values(actions).filter(
      ({ parent }) => (parent as TaskAsParent).parentTask,
    );

    tasksBecomingSubtasks.forEach(({ taskId }) => {
      dispatch(
        updateTaskInProjectTemplate({
          taskId,
          payload: { isTemplate: false },
        }),
      );
    });

    onClose();
  }, [actions, dispatch, onClose]);

  return (
    <Modal
      visible={visible}
      title={useTranslation('templates.rearrange_tasks.title')}
      onCancel={onClose}
      afterClose={() => setActions({})}
      onOk={rearrangeTasks}
      okText={useTranslation('done')}
      destroyOnClose
      maskClosable={false}
    >
      <RearrangeTree
        currentTaskId={currentTaskId}
        updateActions={updateActions}
      />
    </Modal>
  );
};
